import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { SpecialistRetailerForm } from "./SpecialistRetailerForm";

interface UserStandardDetailsProps {
  specialistRetailerName: string;
  specialistRetailerLocation: string;
  specialistRetailerContact: string;
  specialistRetailerCustomerNo: string;
  message: string;
  email: string;
  title: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  setSpecialistRetailerName: (name: string) => void;
  setSpecialistRetailerLocation: (location: string) => void;
  setSpecialistRetailerContact: (contact: string) => void;
  setSpecialistRetailerCustomerNo: (customerNo: string) => void;
  setMessage: (message: string) => void;
  setEmail: (email: string) => void;
  setTitle: (title: string) => void;
  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  setPhoneNumber: (phoneNumber: string) => void;
  isGeolocationDE: boolean;
}

export default function UserStandardDetails({
  specialistRetailerName,
  specialistRetailerLocation,
  specialistRetailerContact,
  specialistRetailerCustomerNo,
  message,
  email,
  title,
  firstName,
  lastName,
  phoneNumber,
  setSpecialistRetailerName,
  setSpecialistRetailerLocation,
  setSpecialistRetailerContact,
  setSpecialistRetailerCustomerNo,
  setMessage,
  setEmail,
  setTitle,
  setFirstName,
  setLastName,
  setPhoneNumber,
  isGeolocationDE,
}: UserStandardDetailsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Box display={"flex"} gap={"1rem"} marginBlock={"1rem"} flexWrap={"wrap"}>
      <SpecialistRetailerForm
        specialistRetailerName={specialistRetailerName}
        specialistRetailerLocation={specialistRetailerLocation}
        specialistRetailerContact={specialistRetailerContact}
        specialistRetailerCustomerNo={specialistRetailerCustomerNo}
        setSpecialistRetailerName={setSpecialistRetailerName}
        setSpecialistRetailerLocation={setSpecialistRetailerLocation}
        setSpecialistRetailerContact={setSpecialistRetailerContact}
        setSpecialistRetailerCustomerNo={setSpecialistRetailerCustomerNo}
        isGeolocationDE={isGeolocationDE}
      />
      <Box
        display={"flex"}
        flexDirection={"column"}
        flex={1}
        flexBasis={"100%"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.message")}</Typography>
        <TextField
          id="outlined-multiline-static"
          multiline
          rows={5}
          value={message}
          onChange={(event) => setMessage(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.email")}*</Typography>
        <TextField
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.title")}</Typography>
        <TextField
          value={title}
          onChange={(event) => setTitle(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.firstName")}*</Typography>
        <TextField
          value={firstName}
          onChange={(event) => setFirstName(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.lastName")}*</Typography>
        <TextField
          value={lastName}
          onChange={(event) => setLastName(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.phoneNumber")}</Typography>
        <TextField
          value={phoneNumber}
          onChange={(event) => setPhoneNumber(event.target.value)}
        />
      </Box>
    </Box>
  );
}
